export default __webpack_public_path__ + "static/media/bassens-2.fe6bbd49.jpg";